/**
 * Whether SATU's e-mail is set up on the server (GET /api/health `surel`, spec 2026-09-30
 * akun 7.2): without it "Lupa kata sandi?" and the e-mail code stay hidden. The last answer is
 * kept for the next launch so the link does not appear late on the sign-in screen. No
 * connection, or a health check that cannot say (the database down answers 503 without
 * `surel`), keeps the last answer.
 */
import { useEffect, useState } from 'react'

// Legacy storage name from SIMU; kept so devices keep their data (pinned: test/nama-warisan.test.ts).
const KUNCI = 'simu:surel'
const API = import.meta.env.VITE_API_BASE || '/api'

export function surelTersimpan(): boolean {
  try {
    return localStorage.getItem(KUNCI) === '1'
  } catch {
    return false
  }
}

export async function periksaSurel(): Promise<boolean> {
  let ada: unknown
  try {
    const response = await fetch(`${API}/health`, { headers: { Accept: 'application/json' } })
    ada = ((await response.json()) as { surel?: unknown }).surel
  } catch {
    return surelTersimpan()
  }
  if (typeof ada !== 'boolean') return surelTersimpan()
  try {
    localStorage.setItem(KUNCI, ada ? '1' : '0')
  } catch {
    // Private browsing: the answer lives for this visit only.
  }
  return ada
}

export function useSurel(): boolean {
  const [ada, setAda] = useState(surelTersimpan)
  useEffect(() => {
    let hidup = true
    void periksaSurel().then((nilai) => {
      if (hidup) setAda(nilai)
    })
    return () => {
      hidup = false
    }
  }, [])
  return ada
}
